import React from 'react';

function Instagram() {
  return (
    <section className="tc-instagram-style6">
      <div className="row gx-0">
        <div className="col-lg-2">
          <a
            href="#"
            className="insta-card wow fadeInUp slow"
            data-wow-delay="0.2s"
          >
            <div className="img h-same-w">
              <img
                src="/home6_furniture/assets/images/instagram/insta1.jpg"
                alt=""
                className="img-cover"
              />
            </div>
            <span className="icon">
              <i className="fab fa-instagram"></i>
            </span>
          </a>
        </div>
        <div className="col-lg-2">
          <a
            href="#"
            className="insta-card wow fadeInUp slow"
            data-wow-delay="0.4s"
          >
            <div className="img h-same-w">
              <img
                src="/home6_furniture/assets/images/instagram/insta2.jpg"
                alt=""
                className="img-cover"
              />
            </div>
            <span className="icon">
              <i className="fab fa-instagram"></i>
            </span>
          </a>
        </div>
        <div className="col-lg-2">
          <a
            href="#"
            className="insta-card wow fadeInUp slow"
            data-wow-delay="0.6s"
          >
            <div className="img h-same-w">
              <img
                src="/home6_furniture/assets/images/instagram/insta3.jpg"
                alt=""
                className="img-cover"
              />
            </div>
            <span className="icon">
              <i className="fab fa-instagram"></i>
            </span>
          </a>
        </div>
        <div className="col-lg-2">
          <a
            href="#"
            className="insta-card wow fadeInUp slow"
            data-wow-delay="0.8s"
          >
            <div className="img h-same-w">
              <img
                src="/home6_furniture/assets/images/instagram/insta4.jpg"
                alt=""
                className="img-cover"
              />
            </div>
            <span className="icon">
              <i className="fab fa-instagram"></i>
            </span>
          </a>
        </div>
        <div className="col-lg-2">
          <a
            href="#"
            className="insta-card wow fadeInUp slow"
            data-wow-delay="1s"
          >
            <div className="img h-same-w">
              <img
                src="/home6_furniture/assets/images/instagram/insta5.jpg"
                alt=""
                className="img-cover"
              />
            </div>
            <span className="icon">
              <i className="fab fa-instagram"></i>
            </span>
          </a>
        </div>
        <div className="col-lg-2">
          <a
            href="#"
            className="insta-card wow fadeInUp slow"
            data-wow-delay="1.2s"
          >
            <div className="img h-same-w">
              <img
                src="/home6_furniture/assets/images/instagram/insta6.jpg"
                alt=""
                className="img-cover"
              />
            </div>
            <span className="icon">
              <i className="fab fa-instagram"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}

export default Instagram;
